import CryptoJS from 'crypto-js'

import api from '@/api'
import { KEY_TUG_MANAGEMENT_DETAIL_ID } from '@/fixtures/Constants'
import { CRYPTO_KEY } from '@/fixtures/Hash'

const encTugManagementId = btoa(KEY_TUG_MANAGEMENT_DETAIL_ID)

const namespaced = true

const state = {
  owners: [],
  horsePowers: [],
  tugManagementId: localStorage.getItem(encTugManagementId) || null,
  tugManagements: [],
  tugManagementDetail: null,
  tugManagementsFiles: {}
}

const getters = {
  owners: state => state.owners,
  horsePowers: state => state.horsePowers,
  tugManagementId: state => state.tugManagementId
    ? Number(CryptoJS.AES.decrypt(state.tugManagementId, CRYPTO_KEY).toString(CryptoJS.enc.Utf8))
    : null,
  tugManagements: state => state.tugManagements,
  tugManagementDetail: state => state.tugManagementDetail,
  tugManagementsFiles: state => state.tugManagementsFiles
}

const mutations = {
  SET_OWNERS: (state, payload) => {
    state.owners = payload
  },
  SET_HORSE_POWERS: (state, payload) => {
    state.horsePowers = payload
  },
  SET_TUG_MANAGEMENT_ID: (state, payload) => {
    state.tugManagementId = payload
    localStorage.setItem(encTugManagementId, payload)
  },
  SET_TUG_MANAGEMENTS: (state, payload) => {
    state.tugManagements = payload
  },
  SET_TUG_MANAGEMENT_DETAIL: (state, payload) => {
    state.tugManagementDetail = payload
  },
  SET_TUG_MANAGEMENTS_FILES: (state, payload) => {
    state.tugManagementsFiles = payload
  }
}

const actions = {
  async fetchOwners({ commit }) {
    try {
      const { data } = await api.getOwners()
      if (data.error) {
        commit('SET_OWNERS', [])
        return
      }

      commit('SET_OWNERS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchHorsePowers({ commit }) {
    try {
      const { data } = await api.getHorsePowers()
      if (data.error) {
        commit('SET_HORSE_POWERS', [])
        return
      }

      commit('SET_HORSE_POWERS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchTugManagements({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage || 1,
        limit: filterConfig.pageSize || 10,
        ...payload
      }
      const { data } = await api.getTugManagements(filter)

      if (data.error) {
        commit('SET_TUG_MANAGEMENTS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_TUG_MANAGEMENTS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async fetchAllTugManagements({ commit }, payload) {
    try {
      const data = await api.getTugManagements(payload)

      if (data.error) {
        commit('SET_TUG_MANAGEMENTS', [])
        return
      }

      commit('SET_TUG_MANAGEMENTS', data.data)
      return data.data
    } catch (err) {
      throw err
    }
  },
  async fetchTugManagementDetail({ commit }, payload) {
    try {
      const { data } = await api.getTugManagementDetail(payload)

      commit('SET_TUG_MANAGEMENT_ID', CryptoJS.AES.encrypt(payload.toString(), CRYPTO_KEY).toString())
      if (data.error) {
        commit('SET_TUG_MANAGEMENT_DETAIL', null)
        return
      }

      commit('SET_TUG_MANAGEMENT_DETAIL', data)
    } catch (err) {
      throw err
    }
  },
  async postTugManagement({}, payload) {
    try {
      await api.postTugManagement(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async putTugManagement({}, payload) {
    try {
      await api.putTugManagement(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteTugManagement({}, payload) {
    try {
      await api.deleteTugManagement(payload)
    } catch (err) {
      throw err
    }
  },
  async downloadTugManagements({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getTugManagementsExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_TUG_MANAGEMENTS_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetTugManagementsFiles({ commit }) {
    commit('SET_TUG_MANAGEMENTS_FILES', {})
  }
}

export default { namespaced, state, getters, mutations, actions }
